import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import registerGlobalComponents from "@/plugins/globalComponents";
import registerUiActions from "./plugins/globalActions";
import VueApexCharts from "vue3-apexcharts";
import vuetify from './plugins/vuetify'
import '@mdi/font/css/materialdesignicons.css'
import '../src/assets/style/index.css'

const app = createApp(App);
const pinia = createPinia();
app.use(router);
app.use(vuetify)
app.use(pinia);
app.use(VueApexCharts);
app.use(registerUiActions);
app.use(registerGlobalComponents);
app.mount("#app");